import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//MUI Components
import { Typography, IconButton, Button } from "@mui/material";
import Spinner from "../../../layout/Spinner";

//Card sections
import PantryItemModalNav from "./item/PantryItemModalNav";
import ItemOnHand from "./item/ItemOnHand";
import ItemPurchaseInfo from "./item/ItemPurchaseInfo";

/*Info to show in on hand
Amount -> Absolute and percentage remaining
Location + Sublocation
Expiry Date
Expand to show change history
+ Waste percentage, add to shopping list
*/
const PantryItemModal = ({ pantry: { item } }) => {
  console.log(item);
  return (
    <>
      {item.loading ? (
        <Spinner />
      ) : item.error ? (
        <Typography variant="h5">Error loading item</Typography>
      ) : (
        <div className="w-full mb-4 ">
          <PantryItemModalNav />

          <div className="px-8 py-4 mt-4 flex flex-col gap-6 w-full">
            <ItemOnHand />
            <ItemPurchaseInfo />
          </div>
        </div>
      )}
    </>
  );
};

PantryItemModal.propTypes = {
  pantry: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
});

export default connect(mapStateToProps)(PantryItemModal);
